import { render, staticRenderFns } from "./AdminProductCategoriesView.vue?vue&type=template&id=3e76ba27&scoped=true"
import script from "./AdminProductCategoriesView.vue?vue&type=script&lang=js"
export * from "./AdminProductCategoriesView.vue?vue&type=script&lang=js"
import style0 from "./AdminProductCategoriesView.vue?vue&type=style&index=0&id=3e76ba27&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3e76ba27",
  null
  
)

export default component.exports